import { Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { CustomValidators } from "../../data/validators";

@Component({
    selector: "app-booking-page",
    templateUrl: "./booking-page.component.html",
    styleUrls: ["./booking-page.component.scss"],
    standalone: false
})
export class BookingPageComponent {
    public fromDate: FormControl = new FormControl(null, [Validators.required, CustomValidators.future]);
    public toDate: FormControl = new FormControl(null, [Validators.required, CustomValidators.future]);
    public numberOfGuests: FormControl = new FormControl(1, [Validators.required]);
    public numberOfChildren: FormControl = new FormControl(0, [Validators.required]);
    public name: FormControl = new FormControl(null, [Validators.required]);
    public address: FormControl = new FormControl(null, [Validators.required]);
    public country: FormControl = new FormControl(null, [Validators.required]);
    public email: FormControl = new FormControl(null, [Validators.required, Validators.email]);
    public phone: FormControl = new FormControl(null, [Validators.required]);

    public form: FormGroup = new FormGroup({
        fromDate: this.fromDate,
        toDate: this.toDate,
        numberOfGuests: this.numberOfGuests,
        numberOfChildren: this.numberOfChildren,
        name: this.name,
        address: this.address,
        country: this.country,
        email: this.email,
        phone: this.phone
    }, [CustomValidators.dateRange("fromDate", "toDate")]);

    constructor() {
    }

    public onSubmit(): void {
        if (this.form.valid) {
            // Handle form submission
            console.log("Form submitted:", this.form.value);
        } else {
            let errors: { [key: string]: any } = {};
            for(let controlKey in this.form.controls) {
                if (this.form.controls[controlKey].invalid) {
                    errors[controlKey] = this.form.controls[controlKey].errors;
                }
            }
            errors['form'] = this.form.errors;
            console.log("Form is invalid:", errors);
        }
    }
}